<template>
    <div>
        <v-page-header
            :back="{
                title: '组织架构',
                goBack: goback,
            }"
            title="从企业微信导入员工"
        />
        <result
            v-if="hasReq"
            :icon="iconName"
            :icon-style="style"
            :title="title"
            :title-style="titleStyle"
            :sub-title="subTitle"
            :describe="describe"
        >
            <template slot="title">
                <p v-if="onStatus == 'alls'" class="v-result-title">
                    <span style="color: #00d48a">{{ importResults.succ }}</span>
                    <span>人全部导入成功</span>
                </p>
                <p v-else class="v-result-title">
                    <span>导入成功</span>
                    <span :style="{ color: onColor }">{{ importResults.succ }}</span>
                    <span>人，失败</span>
                    <span style="color: #f75559">{{ importResults.err }}</span>
                    <span>人</span>
                </p>
            </template>
            <div v-if="buttonText" slot="buttonText" class="button-text">
                <v-button
                    v-if="onStatus === 'parts' || onStatus === 'fail'"
                    status="primary"
                    size="large"
                    @click="downloadFailList"
                >
                    {{ buttonText }}
                </v-button>
                <v-button v-else status="primary" size="large" @click="onCancel(onStatus)">
                    {{ buttonText }}
                </v-button>
                <v-button status="default" size="large" @click="jumpRoute('/mng/org/importStaff')">
                    继续导入
                </v-button>
            </div>
        </result>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
import Result from '@/components/result';
import Gateway from '@/utils/Gateway';
import { envDomain } from 'src/utils/domainConfig';

const req = require.context('../assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);
export default {
    components: {
        Result
    },

    data() {
        return {
            hasReq: false,
            // 图标
            iconName: '',
            style: {},

            // 标题样式
            titleStyle: {},

            // 内容
            title: '',
            subTitle: '',
            buttonText: '',
            describe: '',

            // 当前状态
            onStatus: '',

            // 导入结果数据
            importResults: {},

            // 成功字体颜色
            onColor: '#00D48A',

            // 导出
            exportParams: {
                keyword: '',
                FStatus: -1,
                FlevelId: -1,
                sort: 'modifytime',
                order: 'DESC',
                selectedIds: []
            },
            exportTotal: 1000,
            validator: exportTotal => {
                return exportTotal <= 100000;
            },
            domloadUrl: `${envDomain.gateway}/v1/wework/addressbook/exportManualFailedList`
        };
    },
    created() {
        this.getImportResult();
    },
    methods: {
        goback() {
            window.location.href = '/mng/org';
        },
        getImportResult() {
            Gateway.get('/v1/wework/ManualImportResult')
                .then(data => {
                    const { success, fail, message } = data || {};
                    this.importResults = {
                        succ: success,
                        err: fail,
                        reason: `可能失败原因：${message}`
                    };

                    if (success > 0) {
                        if (fail > 0) {
                            // 部分成功
                            this.onChange(
                                'parts',
                                'partsucces',
                                {
                                    width: 60,
                                    height: 60,
                                    'margin-top': '-30px'
                                },
                                '',
                                {},
                                '下载失败列表',
                                '',
                                this.importResults.reason,
                                '#00D48A'
                            );
                        } else {
                            // 全部成功
                            this.onChange(
                                'alls',
                                'succes',
                                {
                                    width: 60,
                                    height: 60,
                                    'margin-top': '-30px'
                                },
                                '',
                                {},
                                '完成'
                            );
                        }
                    } else {
                        // 全部失败
                        this.onChange(
                            'fail',
                            'errorr',
                            {
                                width: 60,
                                height: 60,
                                'margin-top': '-30px'
                            },
                            '',
                            {},
                            '下载失败列表',
                            '',
                            this.importResults.reason
                        );
                    }

                    this.hasReq = true;
                })
                .catch(message => {
                    this.$message.error(message || '获取导入结果失败');
                });
        },

        jumpRoute(path) {
            this.$router.push(path);
        },

        // 当前状态, 图标name，图标样式，标题，标题样式，按钮，描述，原因，成功字体颜色
        onChange(onStatus, iconName, style, title, titleStyle, buttonText, describe, subTitle, onColor) {
            this.onStatus = onStatus;
            this.iconName = iconName;
            this.style = style;
            this.title = title;
            this.titleStyle = titleStyle;
            this.buttonText = buttonText;
            this.describe = describe;
            this.subTitle = subTitle;
            this.onColor = onColor;
        },

        showByStatus() {
            this.importResults = {
                succ: 40
            };
            this.onChange(
                'alls',
                'succes',
                {
                    width: 60,
                    height: 60,
                    'margin-top': '-30px'
                },
                '',
                {},
                '完成'
            );
        },

        onCancel() {
            window.location.href = '/mng/org';
        },

        downloadFailList() {
            window.location.href = this.domloadUrl;
        }
    }
};
</script>

<style lang="less" scoped>
@import '../style.less';
.export {
    margin-right: 20px;
}
</style>
